module.exports = __webpack_public_path__ + "media/images/xpass/landing_page/phone-with-shadow-a37ab64fb74a94eee310e2f14c340b4c.png";